import { render, staticRenderFns } from "./categoriesTable.vue?vue&type=template&id=53eb1ac3&scoped=true&"
import script from "./categoriesTable.vue?vue&type=script&lang=js&"
export * from "./categoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./categoriesTable.vue?vue&type=style&index=0&id=53eb1ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb1ac3",
  null
  
)

export default component.exports